import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { fetchSnakeByName } from '@terminal/services/overview-widget/overview-widget-service';

const QUERY_KEY_FETCH_SNAKE_BY_NAME_V3 = 'QUERY_KEY_FETCH_SNAKE_BY_NAME_V3';

export const useFetchSnakeByName = (
  snake: string,
  horizonNumberOfDays?: number,
  fromDate?: string,
  isDisabled?: boolean
) =>
  useQuery({
    queryKey: [
      QUERY_KEY_FETCH_SNAKE_BY_NAME_V3,
      snake,
      horizonNumberOfDays,
      fromDate,
    ],
    queryFn: ({ signal }) =>
      fetchSnakeByName(snake, horizonNumberOfDays, fromDate, signal),
    select: data => {
      return {
        tsData: data.data?.result.data,
        meta: data.data?.meta,
      };
    },
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !isDisabled,
  });
